import React from 'react'

const sizeClasses: Record<string, string> = {
  '3': 'h-3 w-3',
  '4': 'h-4 w-4',
  '5': 'h-5 w-5',
  '6': 'h-6 w-6',
  '8': 'h-8 w-8',
  '12': 'h-12 w-12',
  '16': 'h-16 w-16',
}

const myClasses: Record<string, string> = {
  '0': 'my-0',
  '2': 'my-2',
  '4': 'my-4',
  '8': 'my-8',
}

// One spinner for the whole suite. `tone` covers the three contexts it appears in:
// on a surface (brand blue), on a filled/dark button (light), and as a muted inline
// hint (e.g. "generating..."). Every spinner - full-page, section, button, inline -
// should be this component so they all animate identically.
const toneClasses = {
  brand: 'border-perfect-shine',
  light: 'border-white',
  muted: 'border-pacific-storm',
} as const

interface SpinnerProps {
  size?: number | string
  my?: number | string
  tone?: keyof typeof toneClasses
}

function Spinner({ size = 16, my = 4, tone = 'brand' }: SpinnerProps) {
  return (
    <div className={`flex justify-center items-center ${myClasses[String(my)] ?? 'my-4'}`}>
      <div className={`animate-spin rounded-full border-b-2 ${sizeClasses[String(size)] ?? 'h-16 w-16'} ${toneClasses[tone]}`}/>
    </div>
  )
}

export default Spinner
